// China
export const locale = {
	lang: 'ch',
	data: {
		
	}
};
